'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _templateObject = _taggedTemplateLiteral(
  [
    '\n  border-radius: ',
    ';\n  display: inline-block;\n  width: ',
    ';\n  height: ',
    ';\n'
  ],
  [
    '\n  border-radius: ',
    ';\n  display: inline-block;\n  width: ',
    ';\n  height: ',
    ';\n'
  ]
)

var _Box = require('./Box')

var _Box2 = _interopRequireDefault(_Box)

var _propTypes = require('prop-types')

var _propTypes2 = _interopRequireDefault(_propTypes)

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var px = function px(a) {
  return typeof a === 'number' ? a + 'px' : a
}

var Avatar = _Box2.default.withComponent('img').extend(
  _templateObject,
  function(props) {
    return props.theme.pill
  },
  function(props) {
    return px(props.size)
  },
  function(props) {
    return px(props.size)
  }
)

Avatar.displayName = 'Avatar'

Avatar.propTypes = {
  size: _propTypes2.default.oneOfType([
    _propTypes2.default.number,
    _propTypes2.default.string
  ])
}

Avatar.defaultProps = {
  theme: _theme2.default,
  size: 48
}

exports.default = Avatar



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Avatar.js
// module id = 49
// module chunks = 35783957827783 64691314399603 114276838955818 228131777832141